import { render, staticRenderFns } from "./AuthorDetails.vue?vue&type=template&id=3c19abe1&"
import script from "./AuthorDetails.vue?vue&type=script&lang=js&"
export * from "./AuthorDetails.vue?vue&type=script&lang=js&"
import style0 from "./AuthorDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports